import React, { useEffect, useState, useContext, useRef } from "react";
import { AppContext } from "../../context/Context";
import { useTranslation } from "react-i18next";
import "../../assets/css/buttons.css";
import { SocketContext } from "../../context/SocketContext";
import toast from "react-hot-toast";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from "@mui/icons-material/Close";

function ModalReconnect() {
  const { t } = useTranslation();

  const { transactions, updateIsReconnected, updateFocusOnMainScreen } =
    useContext(AppContext);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleCancel = () => {
    updateIsReconnected(false);
  };

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div
            className="react-confirm-alert-body modal-status"
            style={{ width: "760px" }}
          >
            <div className="modal-status-emblem tone-good">
              <CloudDoneIcon />
            </div>
            <h1>{t("socketStatus.reconnectTitle")}</h1>
            {transactions.length > 0 ? (
              <p>{t("socketStatus.reconnectTextTransactions")}</p>
            ) : (
              <p>{t("socketStatus.reconnectTextNoTransactions")}</p>
            )}
            <div
              className="react-confirm-alert-button-group"
              style={{ marginTop: "42px" }}
            >
              <button
                className="btn-custom-yes"
                style={{
                  opacity: transactions.length > 0 ? 0.5 : 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
                onClick={() => {
                  if (transactions.length > 0) {
                    return;
                  }
                  handleRefresh();
                }}
              >
                <RefreshIcon style={{ fontSize: "1.2em" }} />
                {t("socketStatus.refresh")}
              </button>

              <button
                className="btn-custom-no"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
                onClick={() => {
                  handleCancel();
                }}
              >
                <CloseIcon style={{ fontSize: "1.2em" }} />
                {t("socketStatus.notRefresh")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalReconnect;
